export default function Footer()
{
    return (
        <footer className="footer border-top bg-white mt-5 py-3 pb-5 mx-auto mt-auto" id="footer_container">
        <ul className="nav justify-content-center py-3">
          <li className="nav-item"><a href="https://www.usga.org/content/usga/home-page/usga-privacy-policy.html.html" target="_blank" className="nav-link px-2 text-body-secondary">Privacy Policy</a></li>
          <li className="nav-item"><a href="https://www.usga.org/content/usga/home-page/terms-and-conditions.html" target="_blank" className="nav-link px-2 text-body-secondary">Terms and Conditions</a></li>
          <li className="nav-item"><a href="https://www.usga.org/content/usga/home-page/aga/membership-terms.html" target="_blank" className="nav-link px-2 text-body-secondary">Membership Terms</a></li>
          
        </ul>
        <div className="text-center">&copy; 2024 United States Golf Association. All Rights Reserved.</div>
      </footer>
    )
}